import React from 'react';
import { Component } from 'react';
import { connect } from 'redux-scaffolding-ts';
import { WithTranslation, withTranslation } from 'react-i18next';
import { IdentityService } from 'services/identity-service';
import { resolve } from 'inversify-react';
import { replaceAll } from 'utils/useful-functions';
import { ChangeRequestStore, RequestDto, RequestStatus } from 'stores/requests/requests-store';

interface SendRequestButtonTailwindProps extends WithTranslation {
  requestId: string;
  requestStatus: RequestStatus;
  requestCreatorRoles: string[];
  changeRequestStore?: ChangeRequestStore;
  readOnly: boolean;

  onSuccess?: (request: RequestDto) => void;
  onError?: () => void;
  onBeginReOpen?: () => void;
}

@connect(['changeRequestStore', ChangeRequestStore])
class SendRequestButtonTailwind extends Component<SendRequestButtonTailwindProps> {
  @resolve(IdentityService)
  private identityService: IdentityService;

  handleOnClick() {
    if (this.props.onBeginReOpen) this.props.onBeginReOpen();
    this.props.changeRequestStore
      .changeStatus(this.props.requestId, RequestStatus.Draft)
      .then(request => this.props.onSuccess && this.props.onSuccess(request))
      .catch(() => this.props.onError && this.props.onError());
  }

  render() {
    const { t, readOnly } = this.props as any;
    return (
      this.isVisible() && (
        <button
          type="button"
          className={`flex-1 py-2 rounded border 
          ${!readOnly ? 'border-gray-200 text-gray-400' : 'border-gray-400 text-gray-800'}
           font-semibold hover:bg-gray-100 transition-all text-sm`}
          onClick={() => this.handleOnClick()}
          style={{ minWidth: 0 }}
          disabled={!readOnly}
        >
          {t('Reopen')}
        </button>
      )
    );
  }

  isVisible() {
    return this.isVisibleInCurrentStatus() && this.currentUserHasPermission();
  }

  isVisibleInCurrentStatus(): boolean {
    return this.props.requestStatus.toString() === 'Rejected';
  }

  currentUserHasPermission(): boolean {
    const userInfo = this.identityService.getUserInfo();

    if (IdentityService.isAdmin(userInfo)) return true;
    if (IdentityService.isReporting(userInfo)) return false;

    return (this.props.requestCreatorRoles || []).includes(replaceAll(userInfo.activeRole, ' ', ''));
  }
}

export default withTranslation()(SendRequestButtonTailwind);
